import React, { forwardRef, useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const Input = forwardRef(({
  type = 'text',
  placeholder,
  value,
  onChange,
  name,
  id,
  disabled = false,
  error,
  icon: Icon,
  size = 'default',
  className = '',
  ...props
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  const sizeClasses = {
    sm: 'h-9 py-2 pl-3 text-sm',
    default: 'h-12 py-3 pl-4',
    lg: 'h-14 py-4 pl-6 text-lg',
  };

  const paddingRightClasses = {
    sm: isPassword || Icon ? 'pr-9' : 'pr-3',
    default: isPassword || Icon ? 'pr-10' : 'pr-4',
    lg: isPassword || Icon ? 'pr-12' : 'pr-6',
  };

  const baseClasses = `
    w-full rounded-lg border bg-white
    outline-none transition-all duration-200
    focus:border-brand-500 focus-visible:shadow-none
    dark:bg-dark-2 dark:text-white
    disabled:cursor-not-allowed disabled:opacity-50
    ${sizeClasses[size] || sizeClasses.default}
  `;

  const stateClasses = error
    ? 'border-danger focus:border-danger'
    : 'border-stroke dark:border-strokedark';

  const paddingRight = paddingRightClasses[size] || paddingRightClasses.default;

  return (
    <div className="relative">
      <input
        ref={ref}
        type={inputType}
        name={name}
        id={id || name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`${baseClasses} ${stateClasses} ${paddingRight} ${className}`}
        {...props}
      />

      {Icon && !isPassword && (
        <span className={`absolute ${size === 'sm' ? 'right-2.5' : size === 'lg' ? 'right-4' : 'right-3'} top-1/2 -translate-y-1/2 text-body`}>
          <Icon size={size === 'sm' ? 16 : size === 'lg' ? 24 : 18} />
        </span>
      )}

      {isPassword && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className={`absolute ${size === 'sm' ? 'right-2.5' : size === 'lg' ? 'right-4' : 'right-3'} top-1/2 -translate-y-1/2 text-body hover:text-brand-500 transition-colors`}
        >
          {showPassword ? <FiEyeOff size={size === 'sm' ? 16 : size === 'lg' ? 24 : 18} /> : <FiEye size={size === 'sm' ? 16 : size === 'lg' ? 24 : 18} />}
        </button>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
